module.exports = __webpack_public_path__ + "media/svg/selection-steps-fc1913d8.svg";